'use client'
import Avatar from '@/components/avatar'
import Username from '@/components/username'
import { useClientSideAPIKey } from '@/util/url'
import { IChannel } from '@giphy/js-types'
import { SearchBar, SearchContext, SearchContextManager } from '@giphy/react-components'
import { useContext, useEffect, useState } from 'react'

type Props = { onSelect: (channel: IChannel) => void }
const FetchChannels = ({ onSelect }: Props) => {
    const { fetchChannelSearch, term, setChannels, currentChannels, isFocused, setSearch } = useContext(SearchContext)
    const [delayedFocus, setDelayedFocus] = useState(isFocused)
    useEffect(() => {
        const doFetch = async () => {
            const re = await fetchChannelSearch(0)
            setChannels(re)
        }
        if (term) {
            doFetch()
        } else {
            setChannels([])
        }
    }, [term, fetchChannelSearch, setChannels])
    useEffect(() => {
        let timeout: NodeJS.Timeout
        if (!isFocused) {
            // let a click event propagate even after blur
            timeout = setTimeout(() => setDelayedFocus(false), 100)
        } else {
            setDelayedFocus(true)
        }
        return () => clearTimeout(timeout)
    }, [isFocused])
    return delayedFocus && currentChannels?.length > 0 ? (
        <div className="relative">
            <div className="absolute top-1 z-10 max-h-80 w-full divide-y divide-dashed divide-giphyWhite/20 overflow-auto rounded-md bg-giphyDarkCharcoal *:px-3 *:py-3">
                {currentChannels
                    ? currentChannels?.map((channel: IChannel) => {
                          return (
                              <div
                                  className="flex cursor-pointer items-center gap-2 hover:bg-giphyDarkGrey"
                                  key={channel.id}
                                  onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      setSearch('')
                                      onSelect(channel)
                                  }}
                              >
                                  <Avatar user={channel.user} className="pointer-events-none size-12" />
                                  <div className="pointer-events-none text-giphyBlue select-none">
                                      <div key={channel.id}>{channel.display_name}</div>
                                      <Username user={channel.user} />
                                  </div>
                              </div>
                          )
                      })
                    : null}
            </div>
        </div>
    ) : null
}

const SearchInput = ({ onSelect }: Props) => {
    return (
        <SearchContextManager
            apiKey={useClientSideAPIKey()}
            shouldFetchChannels={false}
            theme={{
                darkMode: true,
            }}
        >
            <SearchBar className="flex w-full flex-1" placeholder="Search for Channels" />
            <FetchChannels onSelect={onSelect} />
        </SearchContextManager>
    )
}
export default SearchInput
